import React from "react";
import { twMerge } from "tailwind-merge";
import { CustomButton } from "./CustomButton";

export interface FeatureBenefit {
  label: string;
  icon: React.ReactNode;
  iconBgClass: string;
}

interface FeatureBenefitsCardProps {
  title: string;
  description: string;
  headerIcon: React.ReactNode;
  benefits: FeatureBenefit[];
  ctaLabel?: string;
  onCtaClick?: () => void;
  className?: string;
}

export const FeatureBenefitsCard: React.FC<FeatureBenefitsCardProps> = ({
  title,
  description,
  headerIcon,
  benefits,
  ctaLabel,
  onCtaClick,
  className = "",
}) => {
  return (
    <div
      className={twMerge(
        "rounded-lg border border-gray-200 bg-white p-4",
        className
      )}
    >
      <div className="flex items-start gap-3">
        <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
          {headerIcon}
        </div>
        <div className="min-w-0">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <p className="mt-0.5 text-sm text-gray-500">{description}</p>
        </div>
      </div>

      <ul className="mt-3 grid grid-cols-1 gap-x-6 gap-y-2 border-t border-gray-100 pt-3 sm:grid-cols-2 lg:grid-cols-3">
        {benefits.map((benefit, index) => (
          <li
            key={index}
            className="flex min-w-0 items-center gap-2 text-xs text-gray-700"
          >
            <span
              className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded ${benefit.iconBgClass}`}
            >
              {benefit.icon}
            </span>
            <span className="min-w-0 truncate">{benefit.label}</span>
          </li>
        ))}
      </ul>

      {ctaLabel && onCtaClick && (
        <div className="mt-4 flex">
          <CustomButton
            title={ctaLabel}
            onClick={onCtaClick}
            variant="primary"
            size="sm"
          />
        </div>
      )}
    </div>
  );
};
